import {Component, HostListener, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {AppService} from '../../../../services/app.service';
import {environment} from '../../../../../environments/environment';
import UIkit from 'uikit';
import * as $ from 'jquery';
import {LoadingBarService} from '@ngx-loading-bar/core';

@Component({
  selector: 'app-exclusive-categories',
  templateUrl: './exclusive-categories.component.html',
  styleUrls: ['./exclusive-categories.component.css']
})
export class ExclusiveCategoriesComponent implements OnInit {

  // for categories
  public geoInformation = {};
  responseReceived = false;
  categoriesReceived = false;
  categories: any = [];
  currentCategoryID = ''; // to remove
  currentCategorySlug = ''; // to remove
  selectedCategoryIDs = [];
  selectedCity = '';

  // others
  typeOfListing = 'product'; // product, search

  // for products
  products = [];
  pageNumber = 1;

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private loadingBar: LoadingBarService
  ) {
  }

  ngOnInit(): void {
    this.selectedCity = this.appService.getCurrentCity();

    this.activatedRoute.params.subscribe(params => {
      this.selectedCity = params.city;
      this.currentCategorySlug = params.category;

      if (params.city) {
        localStorage.setItem('city', params.city);
      }

      if (!this.currentCategorySlug) {
        this.getCategories(() => {
          this.filterProducts(this.selectedCategoryIDs.join(','));
        });

      } else {
        this.getCategories(() => {
          this.filterProducts(this.currentCategoryID);
        });
      }
    });
  }


  unSelectCategory(categoryID): void {
    this.categories.EXPERIENCE = [];
    this.currentCategoryID = null;
    this.currentCategorySlug = null;
    this.selectedCategoryIDs = this.selectedCategoryIDs.filter(item => item !== categoryID);
    console.log('filter cats', this.selectedCategoryIDs);
    this.getCategories(r => {
      this.filterProducts();
    });

  }

  onScroll(): void {
    return;

    this.pageNumber++;
    if (this.typeOfListing === 'product') {
      this.getProducts();
    } else {
      this.filterProducts(this.currentCategoryID);
    }

  }


  /**
   * Get all products
   */
  getProducts(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    const params = {page_number: this.pageNumber};

    this.http.post<any>(environment.domain + '/api/products', params, httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        this.loadingBar.stop();
        // this.products.push(...data.products);
        this.products = data.products;
        this.geoInformation = JSON.stringify(data.geo);
        this.typeOfListing = 'product';
      },
      error => {
        console.error('There was an error!', error);
      });
  }

  filterProducts(categoryID = '', animate = false): void {

    if (animate) {
      $('html, body').animate({
        scrollTop: $('#category').offset().top
      }, 500);
    }

    this.currentCategorySlug = null;

    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    const params = {category_id: '', city: '', product_type: 'EXPERIENCE'};
    params.city = this.selectedCity;

    if (categoryID !== '') {
      this.currentCategoryID = categoryID;
      this.selectedCategoryIDs.push(categoryID);
      params.category_id = this.selectedCategoryIDs.join(',');
      console.log('cat ids', this.selectedCategoryIDs);
    } else {
      params.category_id = this.selectedCategoryIDs.join(',');
    }

    this.http.post<any>(environment.domain + '/api/product-search', params, httpOptions).subscribe(
      data => {
        this.responseReceived = true;
        this.loadingBar.stop();
        this.products = data.products;
        this.typeOfListing = 'search';
      },
      error => {
        console.error('There was an error!', error);
      });
  }


  getCategories(callback): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    const params = {page: this.pageNumber};

    this.http.post<any>(environment.domain + '/api/categories', {}, httpOptions).subscribe(
      data => {
        this.categoriesReceived = true;
        this.categories = data.categories;
        this.loadingBar.stop();
        data.categories.EXPERIENCE.forEach((category, index) => {
          if (category.slug === this.currentCategorySlug) {
            this.currentCategoryID = category.id;
          } else {
            if (this.selectedCategoryIDs.length === 0) {
              // this.selectedCategoryIDs.push(category.id);
            }
          }
        });

        callback();

      },
      error => {
        console.error('There was an error!', error);
      });
  }


}
